import CompLayout from "@/pcomponents/comp/layout/layout";

function CounselHistoryListPage(){
  
  return (
    <CompLayout>
      
    </CompLayout>
  );
}

export default CounselHistoryListPage;